module.exports = __webpack_public_path__ + "marque-16c69390b762f20a6514fc40c2ba8fc3.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/images/marque.png
// module id = 231
// module chunks = 0 1 2 11 15